import { useEffect, useRef, useState } from "react";

import { useCurrentAuthUser } from "../../auth";
import { canUsePermission } from "../../../lib/auth";
import { useDicStayAreaRuntime } from "../runtime/useDicStayAreaRuntime";
import type { DicStayAreaItem } from "../types";
import { DicStayAreaFilterPanel } from "./DicStayAreaFilterPanel";
import { DicStayAreaMutationModal } from "./DicStayAreaMutationModal";
import { DicStayAreaResultTable } from "./DicStayAreaResultTable";

type ModalState = { type: "create" } | { type: "edit"; stayArea: DicStayAreaItem };

/** 住宿点字典页面主体。 */
export function DicStayAreaFeaturePage() {
  const deepLinkStayAreaId = new URLSearchParams(window.location.search).get("geoEditId") ?? undefined;
  const runtime = useDicStayAreaRuntime(deepLinkStayAreaId);
  const currentUser = useCurrentAuthUser().data;
  const canManage = canUsePermission(currentUser, "dictionary.stay_area:manage");
  const [modalState, setModalState] = useState<ModalState | null>(null);
  const openedDeepLinkRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!deepLinkStayAreaId || !runtime.deepLinkedItem) return;
    if (openedDeepLinkRef.current === deepLinkStayAreaId) return;
    openedDeepLinkRef.current = deepLinkStayAreaId;
    setModalState({ type: "edit", stayArea: runtime.deepLinkedItem });
  }, [deepLinkStayAreaId, runtime.deepLinkedItem]);

  return (
    <main className="dic-stay-area-page">
      <DicStayAreaFilterPanel
        filters={runtime.draftFilters}
        errorMessage={runtime.errorMessage}
        onChange={runtime.setDraftFilters}
        onReset={runtime.handleReset}
        onSearch={runtime.handleSearch}
      />
      <DicStayAreaResultTable
        canManage={canManage}
        items={runtime.items}
        loading={runtime.loading}
        page={runtime.page}
        pageSize={runtime.pageSize}
        total={runtime.total}
        onCreateStayArea={() => setModalState({ type: "create" })}
        onEditStayArea={(stayArea) => setModalState({ type: "edit", stayArea })}
        onPageChange={runtime.handlePageChange}
        onPageSizeChange={runtime.handlePageSizeChange}
      />
      <DicStayAreaMutationModal
        state={modalState}
        onClose={() => setModalState(null)}
        errorMessage={runtime.mutationErrorMessage}
        geoResolving={runtime.geoResolving}
        geoStatus={runtime.geoStatus}
        geoResult={runtime.geoResult}
        onCreateStayArea={runtime.handleCreateStayArea}
        onUpdateStayArea={runtime.handleUpdateStayArea}
        onResolveGeo={runtime.handleResolveGeo}
        onClearError={runtime.clearMutationError}
        onClearGeoFeedback={runtime.clearGeoFeedback}
      />
    </main>
  );
}
